"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineCommandContract = exports.defineEventContract = exports.defineQueryContract = exports.defineEvent = exports.defineQuery = exports.defineCommand = void 0;
const zod_1 = require("zod");
/**
 * Достать `.shape` из zod-схемы, разворачивая `ZodEffects` (`.refine()`/
 * `.superRefine()`) до внутреннего `ZodObject`. Схемы вида
 * `CommandMessage.extend({...}).refine(...)` иначе бы упали с
 * `Cannot read properties of undefined (reading 'type')` — у `ZodEffects`
 * нет прямого `.shape`.
 */
const extractShape = (schema) => {
    let cur = schema;
    // Разворачиваем ZodEffects до innerType (может быть несколько уровней при
    // цепочке `.refine().refine()`).
    while (cur instanceof zod_1.z.ZodEffects) {
        cur = cur.innerType();
    }
    const shape = cur.shape;
    if (!shape || !shape.type || !shape.version) {
        throw new Error(`defineCommand/defineQuery/defineEvent: schema must be a ZodObject (or ZodEffects of ZodObject) with type+version z.literal fields`);
    }
    return shape;
};
// ── Define factories ──
/**
 * Создать `CommandRoute`. Две формы вызова:
 *
 *   // позиционная (существующий код):
 *   defineCommand('cmd.sbc.desired.sipuser.create', InputSchema, ReplySchema)
 *
 *   // объектная (самодокументирующаяся, удобна для инлайн-определений):
 *   defineCommand({ subject: 'cmd.sbc.desired.sipuser.create', input: InputSchema, reply: ReplySchema })
 */
const defineCommand = (subjectOrOpts, inputSchema, replySchema) => {
    const subject = typeof subjectOrOpts === 'string' ? subjectOrOpts : subjectOrOpts.subject;
    const input = typeof subjectOrOpts === 'string' ? inputSchema : subjectOrOpts.input;
    const reply = typeof subjectOrOpts === 'string' ? replySchema : subjectOrOpts.reply;
    const shape = extractShape(input);
    return {
        kind: 'command',
        subject,
        type: shape.type.value,
        version: shape.version.value,
        inputSchema: input,
        replySchema: reply,
    };
};
exports.defineCommand = defineCommand;
/** Создать `QueryRoute`. Семантика идентична `defineCommand`, отличается только `kind`. */
const defineQuery = (subjectOrOpts, inputSchema, replySchema) => {
    const subject = typeof subjectOrOpts === 'string' ? subjectOrOpts : subjectOrOpts.subject;
    const input = typeof subjectOrOpts === 'string' ? inputSchema : subjectOrOpts.input;
    const reply = typeof subjectOrOpts === 'string' ? replySchema : subjectOrOpts.reply;
    const shape = extractShape(input);
    return {
        kind: 'query',
        subject,
        type: shape.type.value,
        version: shape.version.value,
        inputSchema: input,
        replySchema: reply,
    };
};
exports.defineQuery = defineQuery;
/** Создать `EventRoute`. У event'ов нет reply'я — один payload schema. */
const defineEvent = (subjectOrOpts, payloadSchema) => {
    const subject = typeof subjectOrOpts === 'string' ? subjectOrOpts : subjectOrOpts.subject;
    const payload = typeof subjectOrOpts === 'string' ? payloadSchema : subjectOrOpts.payload;
    const shape = extractShape(payload);
    return {
        kind: 'event',
        subject,
        type: shape.type.value,
        version: shape.version.value,
        payloadSchema: payload,
    };
};
exports.defineEvent = defineEvent;
/** @deprecated Используй `defineQuery(subject, inputSchema, replySchema)`. */
const defineQueryContract = (subject, schema) => ({ subject, schema });
exports.defineQueryContract = defineQueryContract;
/** @deprecated Используй `defineEvent(subject, payloadSchema)`. */
const defineEventContract = (subject, schema) => ({ subject, schema });
exports.defineEventContract = defineEventContract;
/** @deprecated Используй `defineCommand(subject, inputSchema, replySchema)`. */
const defineCommandContract = (subject, schema) => ({ subject, schema });
exports.defineCommandContract = defineCommandContract;
//# sourceMappingURL=subject-contract.js.map